<template>
  <admin-wrapper
    title-translation-path="admin.ZDM_FAILURES"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    @save="saveCard"
    :is-form-fetched="isFormFetched"
  >
    <template #featureCard.input>
      <draggable-lists-manage-card
        :layer-id="layerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        has-edit-attributes
      />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import { call, get } from 'vuex-pathify';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
export default {
  name: 'ZDMFailuresAdmin',
  components: { DraggableListsManageCard, AdminWrapper },
  data: () => ({
    isFormFetched: false,
    hasAnyRequiredOnRightSide: false,
  }),
  computed: {
    dataSourceName: get('admin/modulesMapping@zdm_failures.datasource_name'),
    isModuleEnabled: get('admin/settingsValues@zdm_failures_module_enabled'),
    layerId: get('admin/modulesMapping@zdm_failures.layer_id'),
    currentLayerSchema: get('layers/currentLayerSchema'),
    moduleEnabler() {
      return {
        name: 'zdm_failures_module_enabled',
        translationPath: 'admin.ZDM_FAILURESModule',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.ZDM_FAILURESModule') }),
      };
    },
    inputs() {
      return [
        {
          name: 'zdm_failures_migration_interval_seconds',
          translationPath: 'admin.failureDownloadInterval',
          subtitle: 'admin.failureDownloadIntervalSubtitle',
          outlined: true,
          dense: true,
          align: 'start',
          dataType: { name: 'integer' },
        },
        {
          name: 'featureCard',
          clearable: true,
          translationPath: 'admin.featureCard',
          isCustom: true,
          subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.objectType') }),
          align: 'start',
        },
      ];
    },
  },
  methods: {
    getModulesMapping: call('admin/getModulesMapping'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    editLayer: call('layers/editLayer'),
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.layerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.dataSourceName),
        this.getFeaturesLayer(this.layerId),
        this.getLayerMetadata({ dataSource: this.dataSourceName }),
      ]);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>

<style scoped></style>
